import React, { Component } from "react";
import TestQuestionsContainerListView from "components/test/view/TestQuestionsContainerListView";
import qs from "query-string"
import {getBaseURL} from "components/helpers/HostURLHelper.jsx";


class ReadOnlyTestView extends Component {
  state = {
    testData: null,
    navTestData: null,
    testId: null,
    testInfoData: null,
  };

  componentDidMount() {
    const test_id = qs.parse(this.props.location.search)?.test_id;
    if (!test_id) return;

    this.setState({ testId: test_id });

    $.get(getBaseURL() + "/test/preview?test_id=" + test_id).done((data) => {
      if (data?.template_details?.length > 0) {
        this.initializeTestDataForEditMode(data);
        this.getTestNavigationDataFromTestData(data);
      }
    });
  }

  // Your original data patch logic remains unchanged
  initializeTestDataForEditMode(data) {
    // full logic as you've defined (preserve option injection, fallbacks, etc.)
    // ...
    this.setState({
      testData: data,
      navTestData: this.getTestNavigationDataFromTestData(data),
      testInfoData: data.test_details,
    });
  }

  // Optional: if needed for navigation inside ListView
  getTestNavigationDataFromTestData(data) {
    const questions = data.questions || [];
    return questions.map((q, i) => ({
      question_no: q.question_no,
      subject_short_name: q.subject_short_name,
      index: i,
    }));
  }

  handleTestPrint = (e) => {
    e.preventDefault();
    const { testInfoData } = this.state;
    if (testInfoData?.status !== "COMPLETED") {
      alert("You can only print completed tests.");
      return;
    }

    const printContents = document.getElementById("windowPrint").innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    location.reload(); // refresh back to full view
  };

  render() {
    const { testData, navTestData } = this.state;

    if (!testData) return <div>Loading test...</div>;

    return (
      <div>
        <div id="windowPrint" style={{ height: "100%", backgroundColor: "white" }}>
          <TestQuestionsContainerListView
            completeTestData={testData}
            showAllSolutions={true}
            handleTestPrint={this.handleTestPrint}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

export default ReadOnlyTestView;
